import ReactDatePicker from 'react-datepicker';

import { DATE_TIME_FORMAT } from '../../../constants';
import {
  getFormattedDateInMomentDefaultTZ,
  getNowInDefaultTimezoneAsDate,
} from '../../../helpers';
import { Button, ButtonCallNotes, ButtonGoBack } from '../../Shared';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../styles/react-date-picker.css';

export const Schedule1 = ({
  onChangeSelectedDate,
  onChangeFormObjContact,
  formObjContact,
  setIndex,
  selectedDate,
  handleOpen3,
  formCallNotes,
  resetPitchState,
}) => {
  const minDate = getNowInDefaultTimezoneAsDate();
  const maxDate = new Date(minDate).setFullYear(
    new Date(minDate).getFullYear() + 1,
  );

  const onChange = date => {
    onChangeSelectedDate(date);
    onChangeFormObjContact({
      ...formObjContact,
      apptDate: getFormattedDateInMomentDefaultTZ(date).format(
        DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A,
      ),
    });
  };

  return (
    <>
      <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <div className=" flex gap-6 flex-col items-center">
          <p className="text-brand-900 font-semibold text-[18px]/[24px]">
            What day did you schedule the appointment for?
          </p>
          <ReactDatePicker
            selected={selectedDate}
            onChange={onChange}
            minDate={minDate}
            maxDate={maxDate}
            inline
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            calendarStartDay={1}
          />
        </div>
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            resetPitchState(true);
          }}
        />
        <Button
          title="Next"
          onClick={() => {
            setIndex(3);
          }}
        />
        <ButtonCallNotes
          onClick={handleOpen3}
          hasBg={formCallNotes && formCallNotes !== 'null'}
        />
      </div>
    </>
  );
};
